import Navbar from "../components/Navbar";
import TeamPerson from "../components/TeamPerson";
import Footer from "../components/Footer";
const Team = () => {
  return (
    <>
      <Navbar />
      <TeamPerson />
      <Footer />
    </>
  );
};

export default Team;
